import { DotLottie, DotLottieReact as DotLottieReactOriginal } from '@lottiefiles/dotlottie-react'
import { Box } from '@mui/material'
import { FC, useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { Dialogs, useDialogs } from '../Contexts/DialogsContext'
import { getAssetUrl } from '../utils/assetUrl'

let DotLottieReact: any
if (typeof window !== 'undefined') {
    try {
        const dynamic = require('next/dynamic')
        DotLottieReact = dynamic(() => import('@lottiefiles/dotlottie-react').then((mod) => mod.DotLottieReact), {
            ssr: false,
        })
    } catch {
        DotLottieReact = DotLottieReactOriginal
    }
} else {
    DotLottieReact = DotLottieReactOriginal
}

interface FullscreenAnimationProps {
    animationUrl: string
    onAnimationEnd?: () => void
    backdrop?: boolean
}

export const FullscreenAnimation: FC<FullscreenAnimationProps> = ({
    animationUrl,
    onAnimationEnd,
    backdrop = true,
}) => {
    const [dotLottie, setDotLottie] = useState<DotLottie>()
    const { unregisterDialog } = useDialogs()

    const processedAnimationUrl = getAssetUrl(animationUrl)

    useEffect(() => {
        function onComplete() {
            if (onAnimationEnd) {
                onAnimationEnd()
            } else {
                unregisterDialog(Dialogs.FULLSCREEN_ANIMATION)
            }
        }

        if (dotLottie) {
            dotLottie.addEventListener('complete', onComplete)
        }

        return () => {
            if (dotLottie) {
                dotLottie.removeEventListener('complete', onComplete)
            }
        }
    }, [dotLottie, onAnimationEnd, unregisterDialog])

    const dotLottieRefCallback = (dotLottie: DotLottie) => {
        setDotLottie(dotLottie)
    }

    const content = (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 100000,
                backgroundColor: backdrop ? 'rgba(0, 0, 0, 0.8)' : 'transparent',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Box
                sx={{
                    width: '100%',
                    height: '100%',
                    maxWidth: '600px',
                    maxHeight: '600px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <DotLottieReact
                    dotLottieRefCallback={dotLottieRefCallback}
                    layout={{ fit: 'contain', align: [0.5, 0.5] }}
                    src={processedAnimationUrl}
                    autoplay
                    renderConfig={{
                        autoResize: true,
                    }}
                />
            </Box>
        </Box>
    )

    return typeof window !== 'undefined' ? ReactDOM.createPortal(content, document.body) : content
}

export default FullscreenAnimation
